export default __webpack_public_path__ + "static/media/5.582d1e36.webp";